import React from 'react'
import { useState } from 'react'
import DateFieldValidate from '../../validate/form/date/DateFieldValidate'
import { getDateOnly } from '../../../helpers/date/dateHelper'

const DateFieldMain = ({ required, setValidate, setValueForm, forciblyValue, disabled, label = 'Дата', maxDateType = 'today' }) => {

    const [value, setValue] = useState('')

    // console.log('value', value)

  return (
    <DateFieldValidate
        value={value}
        label={label}
        setValidate={setValidate}
        setValue={e => {
            // console.log('e', e)
            // setValueForm(e)
            setValueForm(getDateOnly(e))
            setValue(getDateOnly(e))
        }}
        required={required}
        maxDateType={maxDateType}
        validates={{
            // isDateBirth18: true
        }}
        forciblyValue={forciblyValue}
        disabled={disabled}
    />
  )
}

export default DateFieldMain